module.exports = __webpack_public_path__ + "img/lookup-pwd-plaid-light.dad43a0.svg";